module.exports = __webpack_public_path__ + "images/pflegegrad5.svg?bac60563a61ab6436be8e4c5480ad423";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pflegegrad5.svg
// module id = aKu9
// module chunks = 0